export default __webpack_public_path__ + "static/img_welfare_11@2x-8e453a07f9c3b92456e5fdb3f7b8a7ba.jpg";